import { render, staticRenderFns } from "./viewNota.vue?vue&type=template&id=5e96d00c&"
import script from "./viewNota.vue?vue&type=script&lang=js&"
export * from "./viewNota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports